const initState = [];

const reducers = {
  addItem(state, payload) {
    const variation = payload.selectedVariation || "";
    const product = `${payload.productId}__${variation}`;

    return {
      ...state,
      [product]: { ...payload, unit: payload.unit },
    };
  },
  removeItem(state, payload) {
    let cartItems = { ...state };
    delete cartItems[payload];
    return cartItems;
  },
  increaseUnit(state, payload) {
    const product = state[payload];

    if (
      product.unit < (product.inStock || product.noInStock) ||
      product.ignoreOutOfStock
    )
      return {
        ...state,
        [payload]: {
          ...product,
          unit: (product.unit += 1),
        },
      };
    return state;
  },
  decreaseUnit(state, payload) {
    const product = state[payload];

    if (product.unit > 1)
      return {
        ...state,
        [payload]: { ...product, unit: (product.unit -= 1) },
      };
    return state;
  },
  clear() {
    return initState;
  },
};

export const cart = {
  state: initState,
  reducers: reducers,
};
